module.exports = __webpack_public_path__ + "img/effect-bg-mini.84a632c6.png";